import { type Terminart, terminart } from '../dtos';

export const terminartLabels = {
  STANDARD: 'Standard',
  ZUSATZ: 'Zusatz',
  ERSATZ: 'Ersatz',
  UNKNOWN: '-',
} as const;

export const printTerminart = (input: Terminart): string => {
  switch (input) {
    case terminart.STANDARD:
      return terminartLabels.STANDARD;
    case terminart.ZUSATZ:
      return terminartLabels.ZUSATZ;
    case terminart.ERSATZ:
      return terminartLabels.ERSATZ;
    case null:
      return terminartLabels.UNKNOWN;
  }
};
